import PageHeader from "@/components/PageHeader";
import { useUsersContext } from "../context";
import { useUserBreadcrumbs } from "../hooks";
import UserDetails from "./UserDetails";
import { UsersAlert } from "./UsersAlert";
import { UsersLoader } from "./UsersLoader";
import { UsersMenu } from "./UsersMenu";
import UsersPermissionsCollapsible from "./UsersPermissionsCollapsible";

const UsersContent = () => {
  const { data, errorState, loadingState } = useUsersContext();
  const { breadcrumbItems } = useUserBreadcrumbs();

  if (loadingState.isLoading) {
    return <UsersLoader reason={loadingState.reason} />;
  }

  if (errorState.error) {
    return (
      <UsersAlert
        title="errors.genericTitle"
        message={errorState.error.message}
      />
    );
  }

  if (!data) {
    return <UsersAlert title="table.noData" message="users.noData" />;
  }

  return (
    <>
      <PageHeader breadcrumbItems={breadcrumbItems} />
      <UsersMenu />
      <div className="space-y-6">
        <UserDetails />
        <UsersPermissionsCollapsible permissions={data.permissions} />
      </div>
    </>
  );
};

export default UsersContent;
